export default "__VITE_ASSET__CrOmbykQ__"